/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Section_TranscriptionInputs */



/**
* | output |
* | --- |
* | "Transcription" |
*
* @param {Options_Editor_Section_TranscriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_section_transcription = /** @type {((inputs?: Options_Editor_Section_TranscriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Section_TranscriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Transcription")
	if (locale === "de") return /** @type {LocalizedString} */ ("Transkription")
	if (locale === "it") return /** @type {LocalizedString} */ ("Trascrizione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Транскрипция")
	if (locale === "es") return /** @type {LocalizedString} */ ("Transcripción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("转录")
	if (locale === "ja") return /** @type {LocalizedString} */ ("転写")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रतिलिपि")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Transcrição")
	return /** @type {LocalizedString} */ ("Transcription")
});